// Alpine
import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
window.Alpine = Alpine;
Alpine.plugin(ajax);
Alpine.start();

// Animations
import Animations from './modules/_animations.js';

// Social share links
import Socials from './modules/_social_share_links.js';

// Dropdown Navigation
import Navigation from './modules/_responsive_navigation.js';

function init() {
  Navigation.setup();
  Animations.setup();
  Socials.setup();
}

init();